import { render, staticRenderFns } from "./AnnualSummary.vue?vue&type=template&id=20198d04&"
import script from "./AnnualSummary.vue?vue&type=script&lang=js&"
export * from "./AnnualSummary.vue?vue&type=script&lang=js&"
import style0 from "./AnnualSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports